module.exports = __webpack_public_path__ + "img/logo-top.0ca8c71a.svg";